import { render, staticRenderFns } from "./UserGearStatistics.vue?vue&type=template&id=9bd130c4&scoped=true"
import script from "./UserGearStatistics.vue?vue&type=script&lang=js"
export * from "./UserGearStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd130c4",
  null
  
)

export default component.exports